import { enumPrinterSortOption } from '@rematter/frontend-lib-api-client';

import { printersListQueryAtom } from '../_graphql/queryPrintersList';

export const $remotePrinters = printersListQueryAtom(() => ({
  variables: {
    sorting: [enumPrinterSortOption.NameAsc],
  },
}));
